if (!customElements.get("page-detail-t4se")) {
  customElements.define(
    "page-detail-t4se",
    class PageDetailT4se extends HTMLElement {
      constructor() {
        super();
        this.$controller = new ScrollMagic.Controller();
        this.$isMobile = window.innerWidth <= 768;
      }

      getPageAffixedHeight() {
        // const areas = document.querySelectorAll(".shopify-section-group-header-group");
        const areas = document.querySelectorAll(".shopify-section--announcement-bar");
        let height = 0;
        areas.forEach((area) => {
          height += area.getBoundingClientRect().height;
        });
        return height;
      }

      createParallaxElement(triggerElement, triggerHook, durationTimes = 1) {
        // 创建一个 Scene，设置 pin 效果
        const scene = new ScrollMagic.Scene({
          triggerElement, // 从这个元素开始触发
          triggerHook, // 触发时在视口顶部（0 表示 top，0.5 是中间）
          duration: Math.max(1080, window.innerHeight) * durationTimes,
        }).addTo(this.$controller);
        return scene;
      }

      initScroll(dom) {
        const slides = dom.querySelectorAll(".slide");
        const btns = dom.querySelectorAll(".paginationz span")
        function render(floatIndex) {
          // 到阈值后直接切换
          const activeIndex = Math.round(floatIndex);
          // 或者 Math.floor(floatIndex)
          // 或者自定义阈值

          slides.forEach((slide, i) => {
            const active = i === activeIndex;

            slide.style.opacity = active ? 1 : 0;
            slide.style.zIndex = active ? 10 : 0;
            slide.style.pointerEvents = active ? "auto" : "none";
          });
        }
        // function render(floatIndex) {
        //   slides.forEach((slide, i) => {
        //     const distance = Math.abs(i - floatIndex);
        //     // 越接近越清晰
        //     let opacity = 1 - distance;
        //     if (opacity < 0) opacity = 0;
        //     if (opacity > 1) opacity = 1;
        //     // 🎯 加一点缓动（关键）
        //     opacity = opacity * opacity;
        //     slide.style.opacity = opacity;
        //     // 层级防止遮挡
        //     slide.style.zIndex = Math.round(opacity * 10);
        //   });
        // }
        const scene = this.createParallaxElement(dom, 0, 1.5)
        .setPin(dom)
        .offset(-this.getPageAffixedHeight())
        .on("progress", (event) => {
          const progress = event.progress;
          const max = slides.length - 1;
          const floatIndex = progress * max;
          render(floatIndex);
          const activeIndex = Math.round(floatIndex);
          btns.forEach((btn, i) => {
            btn.classList.toggle( "active", i === activeIndex );
          });
        });
        let target = 0;
        let current = 0;
        let animating = false;
        function smoothScrollTo(target, duration = 800) {
          const start = window.scrollY;
          const distance = target - start;
          const startTime = performance.now();
          function animate(time) {
            const elapsed = time - startTime;
            const t = Math.min(elapsed / duration, 1);
            // easeInOutCubic
            const ease = t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
            window.scrollTo( 0, start + distance * ease );
            if (t < 1) {
              requestAnimationFrame(animate);
            }
          }
          requestAnimationFrame(animate);
        }
        btns.forEach((btn, index) => {
          btn.addEventListener("click", () => {
            const progress = index / (slides.length - 1);
            const startY = scene.scrollOffset();
            const duration = scene.duration();
            const targetY = startY + duration * progress;
            smoothScrollTo(targetY, 700);
          });
        });
      }
      initS4() {
        const s4 = this.querySelector(".s4");
        if(this.$isMobile) {
          const m = s4.querySelector(".swiper-m");
          const btns = m.querySelectorAll(".paginationz span");
          const swiper = new Swiper(m, {
            slidesPerView: 'auto',
            spaceBetween: 12,
            navigation: {
              nextEl: m.querySelector('.swiper-button-next'),
              prevEl: m.querySelector('.swiper-button-prev'),
            },
            on: {
              slideChange: function() {
                btns.forEach((btn, i) => {
                  btn.classList.toggle("active", this.activeIndex >= i * 3 && this.activeIndex < (i + 1) * 3)
                })
              }
            }
          })
          btns.forEach((btn, i) => {
            btn.addEventListener("click", () => {
              swiper.slideTo(i * 3);
              btns.forEach((b) => {
                b.classList.remove("active");
              })
              btn.classList.add("active");
            });
          })
        } else {
          this.initScroll(s4);
        }
      }
      initS5() {
        const s5 = this.querySelector(".s5");
        if(this.$isMobile) {
          const container = s5.querySelector(".swiper-container");
          const btns = s5.querySelectorAll(".paginationz span");
          const swiper = new Swiper(container, {
            slidesPerView: 'auto',
            spaceBetween: 0,
            on: {
              slideChange: function() {
                btns.forEach((btn, i) => {
                  btn.classList.toggle("active", this.activeIndex === i);
                })
              }
            }
          })
          btns.forEach((btn, i) => {
            btn.addEventListener("click", () => {
              swiper.slideTo(i);
              btns.forEach((b) => {
                b.classList.remove("active");
              })
              btn.classList.add("active");
            });
          })
        } else {
          this.initScroll(s5);
        }
      }
      initS6() {
        const s6 = this.querySelector(".s6");
        if(this.$isMobile) {
          const container = s6.querySelector(".swiper-container");
          const swiper = new Swiper(container, {
            slidesPerView: 'auto',
            spaceBetween: 16,
            pagination: {
              el: s6.querySelector(".swiper-pagination"),
              clickable: true,
            },
            on: {
              slideChange: function() {
                
              }
            }
          })
        }
      }
      initS8() {
        const s8 = this.querySelector('.s8');
        if(this.$isMobile) {
          const container = s8.querySelector(".swiper-container");
          const swiper = new Swiper(container, {
            slidesPerView: 'auto',
            spaceBetween: 16,
            pagination: {
              el: container.querySelector(".swiper-pagination"),
              clickable: true,
            },
            on: {
              slideChange: function() {
                
              }
            }
          })
        } else {
          let current = 0;
          const items = s8.querySelectorAll(".pc .list .item");
          const imgs = s8.querySelectorAll(".pc .imgs img");
          items.forEach((item, index) => {
            const title = item.querySelector(".title");
            const desc = item.querySelector(".desc");
            title.addEventListener("click", () => {
              const isOpen = item.classList.contains("active");
              items.forEach(otherItem => {
                if (otherItem !== item) {
                  const otherDesc = otherItem.querySelector(".desc");
                  collapse(otherDesc);
                  otherItem.classList.remove("active");
                }
              });
              if (isOpen) {
                // collapse(desc);
                // item.classList.remove("active");
              } else {
                expand(desc);
                item.classList.add("active");
              }
              // img
              if (index === current) return;
              imgs[current].classList.remove( "active" );
              imgs[index].classList.add( "active" );
              current = index;
            });
            function expand(el) {
              el.style.height = "0px";
              const height = el.scrollHeight;
              requestAnimationFrame(() => {
                el.style.height = height + "px";
              });
              el.addEventListener(
                "transitionend",
                () => {
                  el.style.height = "auto";
                },
                { once: true }
              );
            }

            function collapse(el) {
              const height = el.scrollHeight;
              el.style.height = height + "px";
              requestAnimationFrame(() => {
                el.style.height = "0px";
              });
            }
          });
        }
      }
      initS10() {
        if (this.$isMobile) {
          
        } else {
          const s10 = this.querySelector(".s10");
          const bg = s10.querySelector(".bg");
          const shadow = s10.querySelector(".shadow");
          const text = s10.querySelector(".text");
          const list = text.querySelector(".list");
          this.createParallaxElement(s10, 0.05, 1.3)
          .setPin(s10)
          .offset(-this.getPageAffixedHeight())
          .on("progress", (event) => {
            const progress = event.progress;
            text.style.transform = `translateY(${(1 - progress) * 51}%)`;
            list.style.opacity = progress;
            shadow.style.opacity = progress;
            bg.style.filter = `blur(${progress * 10}px)`;
            // bg.style.transform = `scale(${1 + progress * 0.05})`;
            shadow.style.filter = `blur(${progress * 10}px)`;
          });
        }
      }
      initS12() {
        const s12 = this.querySelector('.s12');
        const btns = s12.querySelectorAll(".paginationz .item");
        if(this.$isMobile) {
          const container = s12.querySelector(".swiper-container");
          const swiper = new Swiper(container, {
            slidesPerView: 'auto',
            spaceBetween: 16,
            on: {
              slideChange: function() {
                btns.forEach((btn, i) => {
                  btn.classList.toggle("active", this.activeIndex === i);
                })
              }
            }
          })
          btns.forEach((btn, i) => {
            btn.addEventListener("click", () => {
              swiper.slideTo(i);
              btns.forEach((b) => {
                b.classList.remove("active");
              })
              btn.classList.add("active");
            });
          })
        } else {
          let current = 0;
          const items = s12.querySelectorAll(".swiper-wrapper .swiper-slide");
          btns.forEach((btn, index) => {
            btn.addEventListener("click", () => {
              const isActive = btn.classList.contains("active");
              btns.forEach(otherBtn => {
                if (otherBtn !== btn) {
                  otherBtn.classList.remove("active");
                }
              });
              if (!isActive) {
                btn.classList.add("active");
              }
              if (index === current) return;
              items[current].classList.remove( "active" );
              items[index].classList.add( "active" );
              current = index;
            });
          });
        }
      }
      initS16() {
        const s16 = this.querySelector(".s16");
        const dialPlate = s16.querySelector(".dial-plate");
        const dialPlatePlayer = new ResponsiveSpritePlayer(dialPlate, {
          cols: 11,
          rows: 11,
          fps: 30,
          offsetX: 0,
          loop: true,
        });
        dialPlatePlayer.start();
      }

      initS17() {
        const wrapper = this.querySelector(".s17");
        const os = wrapper.querySelector(".os");
        const content_1 = wrapper.querySelector(".content-1");
        const content_2 = os.querySelector(".content-2");
        const content_3 = os.querySelector(".content-3");
        const svgFramePlayer = new SvgFramePlayer(os.querySelector(".svg-frame-player"), {
          fps: 16,
          loop: true,
        });
        this.createParallaxElement(wrapper, 0, 1.6)
          .setPin(wrapper)
          .offset(-this.getPageAffixedHeight())
          .on("progress", (event) => {
            const progress_2 = Math.max(event.progress - 0.2, 0);
            svgFramePlayer.goTo(Math.round(event.progress * 107));
            content_1.style.transform = `translateY(-${100 * event.progress * 3}px)`;
            content_1.style.opacity = Math.max(1 - event.progress * 3, 0);
            content_2.style.transform = `translateY(${100 * Math.max(1 - progress_2 * 4, 0)}px)`;
            content_2.style.opacity = Math.min(progress_2 * 4, 1);
            if (progress_2 > 0) {
              content_3.style.transform = `translateY(${100 * Math.max(1 - progress_2 * 4, 0)}px)`;
              content_3.style.opacity = Math.min(progress_2 * 4, 1);
            } else {
              content_3.style.opacity = 0;
            }
          });
      }

      initAnchorEvents() {
        const spans = this.querySelectorAll("[data-apex-anchor-to]");
        spans.forEach((span) => {
          span.addEventListener("click", (e) => {
            const anchorTarget = span.dataset.apexAnchorTo;
            const anchor = this.querySelector(`[data-apex-anchor="${anchorTarget}"]`);
            anchor.scrollIntoView({ behavior: "smooth" });
          });
        });
      }

      connectedCallback() {
        document.addEventListener("DOMContentLoaded", () => {
          if (window.innerWidth > 768) {
          } else {
          }
          this.initS4();
          this.initS5();
          this.initS6();
          this.initS8();
          this.initS10();
          this.initS12();
          this.initS16();
          this.initS17();
          // ---------------------
          this.initAnchorEvents();
        });
      }
    }
  );
}
